import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGateways } from '@/contexts/gateways'
import { EditLayout } from '@/layouts'
import FullPageSpinner from '@/shared/components/FullPageSpinner'
import DataTable, { getUniformedColumns } from "@/shared/components/DataTable";

import {
  Box, HStack, Text, Center, Heading
} from '@chakra-ui/react'
import { StaticRow, SectionWithTitle } from '@/components/elements'
import { useIsMobile, useIsTablet } from "../../hooks";
import { useTranslation } from 'react-i18next' 

const Gateway = (props) => {
  const sectionPadding = { base: 4, md: 8 };
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const { t } = useTranslation(['general', 'minds'])
  const { id } = useParams()
  const { gateways, isFetching } = useGateways()
  
  const [gateway, setGateway] = useState(null)

  useEffect(() => {
    if (gateways && id) {
      const foundGateway = gateways.find(g => g.device_serial === id || g.serial === id || g.id === parseInt(id))
      setGateway(foundGateway)
    }
  }, [gateways, id])

  const machinesColumnsProps = {
    serial: {
      text: t('general:serial', 'serial').toCapitalCase(),
      sort: true,
    },
    name: {
      text: t('general:name', 'name').toCapitalCase(),
      sort: true,
    },
    machine_model: {
      text: t('general:model', 'model').toCapitalCase(),
      sort: true,
    },
    connection: {
      text: t('general:connection', 'connection').toCapitalCase(),
      sort: true,
    }
  };

  const machinesColumns = getUniformedColumns(Object.keys(machinesColumnsProps), machinesColumnsProps);

  if (isFetching) {
    return <FullPageSpinner />
  }

  if (!gateway) {
    return (
      <EditLayout>
        <Box p={8}>
          <Text>{t('general:gatewayNotFound', 'Gateway not found')}</Text>
        </Box>
      </EditLayout>
    )
  }

  return (
    <EditLayout>
      <SectionWithTitle
        title={t('general:gatewayDetails', 'Gateway Details')}
      >
        <Box px={sectionPadding}>
          <StaticRow 
            label={t('general:deviceSerial', 'Device Serial')} 
            content={gateway.device_serial || '-'} 
          />
          <StaticRow 
            label={t('general:serial', 'serial').toCapitalCase()} 
            content={gateway.serial || '-'} 
          />
          <StaticRow 
            label={t('general:FirstAdded', 'First Added')} 
            content={gateway.first_added || '-'} 
          />
          <StaticRow 
            label={t('general:LastSeen', 'Last Seen')} 
            content={gateway.last_seen || '-'} 
          />
          <StaticRow 
            label={"WireGuard IP"}
            content={gateway.wireguard_ip || '-'}
          />
          <StaticRow
            label={t('general:ipMind', 'Mind IP')}
            content={gateway.mind_ip || '-'}
          />
          <StaticRow 
            label={t('general:deviceConfiguration', 'Device Configuration')} 
            content={gateway.device_configuration || '-'} 
          />
          <StaticRow 
            label={t('general:OperatingSystem', 'Operating System')} 
            content={`${gateway.operating_system} ${gateway.os_version}`} 
          />
          <StaticRow 
            label={t('general:SwVersion', 'Sw Version')} 
            content={gateway.sw_version || '-'} 
          />

        </Box>
      </SectionWithTitle>

      <SectionWithTitle
        title={t('general:machines', 'Machines').toCapitalCase()}
      >
        <Box px={sectionPadding}>
          <DataTable
            data={gateway.machines}
            columns={machinesColumns}
            noDataIndication={<Center>{t('general:NoData', "No machines")}</Center>}
            customSizePerPage={10}
            hidePagination={gateway.machines.length <= 10}
          />
        </Box>
      </SectionWithTitle>
    </EditLayout>
  )
}

export default Gateway